import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import { getAllAnswers } from '../../../utils/onboardingStorage'

export default function TransformationReadyFeedbackPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  // Get the change readiness answer
  const allAnswers = getAllAnswers()
  const readiness = parseInt(allAnswers.changeReadiness?.answer_key || '3')
  const highlyReady = readiness >= 4

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <FeedbackPage
      emoji="🚀"
      heading={t(
        highlyReady
          ? 'pages.onboarding.v1.transformationReadyFeedback.highReady.heading'
          : 'pages.onboarding.v1.transformationReadyFeedback.lowReady.heading',
      )}
      text={t(
        highlyReady
          ? 'pages.onboarding.v1.transformationReadyFeedback.highReady.description'
          : 'pages.onboarding.v1.transformationReadyFeedback.lowReady.description',
      )}
      onSubmit={handleSubmit}
    />
  )
}
